import Api from '@/services/Api'

const BASE = 'auth'

const LOGIN_ENDPOINT = `${BASE}/login`
const LOGOUT_ENDPOINT = `${BASE}/logout`
const REGISTER_ENDPOINT = `${BASE}/register`
const REQUEST_PASSWORD_RESET_ENDPOINT = `${BASE}/password/email`
const NEW_PASSWORD_ENDPOINT = `${BASE}/password/reset`
const VERIFY_EMAIL = `${BASE}/verify-email`
const RESEND_CONFIRMATION = `${BASE}/verify-email/resend`

export const AuthApiService = {
  login (formData) {
    return Api.postData(LOGIN_ENDPOINT, formData)
  },
  logout () {
    return Api.delete(LOGOUT_ENDPOINT)
  },
  register (formData) {
    return Api.postData(REGISTER_ENDPOINT, formData)
  },
  forgottenPassword (email) {
    return Api.postData(REQUEST_PASSWORD_RESET_ENDPOINT, email)
  },
  fetchLogedInUser () {
    return Api.getData('user')
  },
  fetchUser (userId) {
    return Api.getData(`users/${userId}`)
  },
  verifyEmail (key) {
    return Api.post(VERIFY_EMAIL, { key })
  },
  resetPassword (formData) {
    return Api.postData(NEW_PASSWORD_ENDPOINT, formData)
  },
  resendConfirmation (formData) {
    return Api.postData(RESEND_CONFIRMATION, formData)
  }
}
